<template>
  <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      @select="handleSelect"
  >
    <div class="d-flex align-items-center justify-content-center mx-100">
      <!-- Use <template v-for> to avoid mixing v-if + v-for on the same element (Vue 3 priority bug) -->
      <template v-for="(category, index) in categories" :key="index">

        <!-- Category has NO children → plain link -->
        <el-menu-item
            v-if="category.grandchildren.length === 0"
            :index="`/products?category=${category.slug}`"
            @click="clickCategory(category.slug)"
        >
          <span style="margin: 0px 20px">{{ category.name }}</span>
        </el-menu-item>

        <!-- Category HAS children → dropdown -->
        <el-sub-menu
            v-else
            :index="`/products?category=${category.slug}`"
        >
          <template #title>
            <p @click="clickCategory(category.slug)" style="margin: 0px 20px">{{ category.name }}</p>
          </template>

          <template v-for="(child, childIndex) in category.grandchildren" :key="childIndex">

            <!-- Child has NO grandchildren → plain item -->
            <el-menu-item
                v-if="child.grandchildren.length === 0"
                :index="`${index}-${childIndex}`"
                @click="clickCategory(child.slug)"
            >
              {{ child.name }}
            </el-menu-item>

            <!-- Child HAS grandchildren → nested dropdown -->
            <el-sub-menu
                v-else
                :index="`${index}-${childIndex}`"
            >
              <template #title>
                <p @click="clickCategory(child.slug)">{{ child.name }}</p>
              </template>
              <el-menu-item
                  v-for="(grand, grandIndex) in child.grandchildren"
                  :key="grandIndex"
                  :index="`${index}-${childIndex}-${grandIndex}`"
                  @click="clickCategory(grand.slug)"
              >
                {{ grand.name }}
              </el-menu-item>
            </el-sub-menu>

          </template>
        </el-sub-menu>

      </template>
    </div>
  </el-menu>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SubHeader',
  data() {
    return {
      activeIndex: '',
      categories: [],
    };
  },
  created() {
    this.getCategory();
  },
  methods: {
    getCategory() {
      axios.get(`/api/web/categories`)
          .then(res => {
            this.categories = this.normalizeCategories(res.data.data || []);
          });
    },
    normalizeCategories(items) {
      return items.map(item => ({
        ...item,
        grandchildren: this.normalizeCategories(item.grandchildren || []),
      }));
    },
    handleSelect(key, keyPath) {
      console.log('kay', key, 'keypath', keyPath);
    },
    clickCategory(slug) {
      this.$router.push(`/products?category=${slug}`);
    },
  }
};
</script>

<style>
.el-menu-demo {
  border-bottom: 0px;
}
</style>
